import { render, staticRenderFns } from "./OpenInvoices.vue?vue&type=template&id=da2c95f8&scoped=true"
import script from "./OpenInvoices.vue?vue&type=script&lang=js"
export * from "./OpenInvoices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da2c95f8",
  null
  
)

export default component.exports